<template>
  <label class="block">
    <span v-if="label" class="mb-1 flex items-center">
      <h4 v-if="!tooltip" :class="{ 'text-bittersweet-600': isError }">{{ label }}</h4>

      <Information v-else
        ><template #text
          ><span class="font-semibold" :class="{ 'text-bittersweet-600': isError }">{{
            label
          }}</span></template
        ><template #modal>{{ tooltip }}</template></Information
      >

      <span
        v-if="warning"
        class="ml-2 rounded-full bg-bittersweet-600 pb-[1px] pl-2 pr-2 pt-[1px] text-xs text-white"
      >
        {{ warning }}
      </span>
    </span>
    <slot />
  </label>
</template>

<script lang="ts" setup>
import Information from './Information.vue';

defineProps<{
  label?: string;
  tooltip?: string;
  isError?: boolean;
  warning?: string;
}>();
</script>
